import React, { useContext } from 'react'
import { UserContext, UserPayload } from '../Context/userContext';
import { Navigate } from 'react-router-dom';
import RoundLoader from '../Components/loader/Loader';
import { AuthStatusEnum } from '../constants/authConstants';

interface PublicOnlyRouteProps {
    children: React.ReactNode;
}

export const PublicOnlyRoute = ({ children }: PublicOnlyRouteProps) => {
    const { authStatus } = useContext(UserContext) as UserPayload;

    if(authStatus === AuthStatusEnum.IDLE || authStatus === AuthStatusEnum.LOADING) {
        return <RoundLoader />
    }

    if(authStatus === AuthStatusEnum.AUTHENTICATED) {
        return <Navigate to="/insights" replace />
    }

    return <>{children}</>;
}
